import { render, staticRenderFns } from "./PartidaForm.vue?vue&type=template&id=1c57db29"
import script from "./PartidaForm.vue?vue&type=script&lang=js"
export * from "./PartidaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports